import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);
  const toggle = () => setOpen(prev => !prev);

  // Add ripple effect to nav links
  // const addRipple = (e) => {
  //   const target = e.currentTarget;
  //   const rect = target.getBoundingClientRect();
  //   const size = Math.max(rect.width, rect.height);
  //   const x = e.clientX - rect.left;
  //   const y = e.clientY - rect.top;
  //   const ripple = document.createElement("span");
  //   ripple.className = "ripple";
  //   ripple.style.width = size + "px";
  //   ripple.style.height = size + "px";
  //   ripple.style.left = x + "px";
  //   ripple.style.top = y + "px";
  //   target.appendChild(ripple);
  //   setTimeout(() => {
  //     ripple.remove();
  //   }, 600);
  // };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("drawer-open");
    } else {
      document.body.classList.remove("drawer-open");
    }
  }, [open]);

  return (
    <>
      <header className="navbar">
        {/* <img src="/images/logo.png" alt="ColorSplash Paints" className="logo" style={
          {
           width: "100px",
           height: "100px", 
          }
        }/> */}
        <div className="brand">Vinayaka Enterprises</div>
        <nav className="nav-links">
          <NavLink to="/" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>Home</NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>About</NavLink>
          {/* <NavLink to="/products" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>Products</NavLink> */}
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>Contact</NavLink>
        </nav>
        <button
          className={"hamburger" + (open ? " active" : "")}
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="mobile-drawer"
          onClick={toggle}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </header>

      <div className={"drawer-overlay" + (open ? " visible" : "")} onClick={close} />

      <aside
        id="mobile-drawer"
        className={"mobile-drawer" + (open ? " open" : "")}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
      >
        <div className="drawer-header">
          <div className="brand">Sri Vinayaka Enterprises</div>
        </div>
        <nav className="drawer-nav">
          <NavLink to="/" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link") } onClick={close}>Home</NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link") } onClick={close}>About</NavLink>
          {/* <NavLink to="/products" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link") } onClick={close}>Products</NavLink> */}
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link") } onClick={close}>Contact</NavLink>
        </nav>
      </aside>
    </>
  );
};

export default Navbar;